export function getImages(folderName) {
  if (!folderName) return [];

  const context = require.context(
    "./assets",
    true,
    /\.(png|jpe?g|svg|webp)$/i
  );

  return context
    .keys()
    .filter((path) =>
      (path || "")
        .toLowerCase()
        .includes(folderName.toLowerCase())
    )
    .sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)?.[0] || 0);
      const numB = parseInt(b.match(/\d+/)?.[0] || 0);
      return numA - numB;
    })
    .map(context);
}